import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { id, meta, entityItems, users, authorizedTo } from '@/services/api';

export const data = t.type({
  title: t.string,
  checklistId: t.number,
  assignees: users,
  entityItems,
  allEntityItems: t.boolean,
  availableAt: DateFromUnixTime,
  dueAt: t.union([DateFromUnixTime, t.null]),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});
